import React from "react";
import PropTypes from "prop-types";
import ActionWithModal from "./action-with-modal";
import { injectIntl } from "react-intl";

const DeleteActionWithModal = ({
  history,
  intl,
  actionButton = false,
  elementToDelete,
  urlOnSuccess,
  refetchDataOnSuccess = false,
  refetchData,
  event,
  disableIcon,
  item,
  showLoading = true,
  descriptionText = null,
  ...props
}) => {
  const content = intl.formatMessage(
    { id: descriptionText || "app.dialog.delete.text" },
    {
      element: elementToDelete
        ? elementToDelete
        : intl.formatMessage({ id: "app.dialog.delete.elementToDelete.default" }),
    },
  );

  const handleSuccess = () => (actionButton && history.push(urlOnSuccess)) || (refetchDataOnSuccess && refetchData());

  return (
    <ActionWithModal
      showLoading={showLoading}
      actionButton={actionButton}
      dialogTitle={intl.formatMessage({ id: "app.dialog.delete.title" })}
      renderDialogContent={() => content}
      onSuccess={handleSuccess}
      refetchData={refetchData}
      icon="delete"
      event={event}
      disableIcon={disableIcon}
      item={item}
      intl={intl}
      {...props}
    />
  );
};

DeleteActionWithModal.propTypes = {
  /**
   * Texto para mostrar en un tooltip en caso de que el botón esté deshabilitado.
   * En caso de no haber texto, no se muestra el tooltip
   **/
  disabledTooltipText: PropTypes.string,
  /**
   * Indica si se muestra el spinner de loading
   **/
  showLoading: PropTypes.bool,
  /**
   * Indica si el botón está deshabilitado
   **/
  disabled: PropTypes.bool,
  /**
   * Url a redirigir si hay éxito, por defecto se recarga la misma página
   **/
  urlOnSuccess: PropTypes.string,
  /**
   * Indica si se muestra como un botón de acción
   **/
  actionButton: PropTypes.bool,
  /**
   * Indica si se debe hacer un refetch al hacer el borrado
   */
  refetchDataOnSuccess: PropTypes.bool,
  /**
   * Función de refetch de datos
   */
  refetchData: PropTypes.func,
  /**
   * Función mutación de Apollo
   **/
  mutation: PropTypes.func,
  /**
   * Clave del mensaje que se usa como contenido del diálogo.
   **/
  descriptionText: PropTypes.string,
  /**
   * Objeto variables de parámetros de mutación
   **/
  mutationVariables: PropTypes.object,
  /**
   * Nombre del elemento en el resultado de la query (result.data[elementNameInResult].id)
   **/
  elementNameInResult: PropTypes.string,
  /**
   * Nombre identificativo para el usuario del elemento a eliminar
   **/
  elementToDelete: PropTypes.string,
};

export default injectIntl(DeleteActionWithModal);
